﻿
import { ajaxRequest } from '../../utilities/ajax';

export const tracking = () => {
  
    const bindEvents = (link, goalId) => {
        link.addEventListener('click', () => {
            const data = { goalId };

            ajaxRequest.post('/api/marketing/triggergoal', JSON.stringify(data), 'application/json');
        });
    };

    const init = link => {
        const goalId = link.getAttribute('data-goal');

        if (goalId) {
            bindEvents(link, goalId);
        }
    };

    return {
        init: init,
        selector: 'a[data-goal]'
    };
};
